/**
 * Created by Alican Köker on 2018-08-28.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {TimelineLite} from "gsap";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";
import {FruitsReelController} from "../reel/reel/FruitsReelController";
import {FruitsReelPartAnimator} from "../reel/reel/FruitsReelPartAnimator";
import {FruitsReelAreaView} from "../reel/reelarea/FruitsReelAreaView";
import {FruitsReelSymbol} from "../reelsymbol/FruitsReelSymbol";
import {FruitsParsedGameData} from "../server/data/FruitsParsedGameData";
import {FruitsParsedInitData} from "../server/data/FruitsParsedInitData";
import {FruitsHelper} from "../utils/FruitsHelper";
import { FruitsGameModuleConfig } from "../FruitsGameModuleConfig";

export class FruitsBonusGameController extends BaseController {
    private _initialBonusPositions:boolean[][];
    private _isRestoreState:boolean;
    private _reelsEnteringBonus:string[][];
    private _bonusOverlayPositions:boolean[][];
    private _currentBonusPaytable:number[];
    private _currentBonusIndex:number;
    private _nextBonusIndex:number;
    private _currentScatterLevel:number = 1;

    public static readonly UPDATE_SCATTER_SYMBOLS:string = "fruitsBonusGameController_updateScatterSymbols";
    public static readonly RESTORE_REELSET_TO_BEFORE_LAST_BONUS:string = "fruitsBonusGameController_restoreReelsetToBeforeLastBonusSpin";

    constructor() {
        super();
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, FruitsReelAreaView.GAME_MODE_SWITCHING_COMPLETED, (event:GameEvent) => this.onChangeMode(event.params[0]));
        EventHandler.addEventListener(this, FruitsBonusGameController.UPDATE_SCATTER_SYMBOLS, (event:GameEvent) => this.updateScatters());
        EventHandler.addEventListener(this, FruitsBonusGameController.RESTORE_REELSET_TO_BEFORE_LAST_BONUS, (event:GameEvent) => this.restoreReelsetToBeforeLastBonusSpin());

    }

    protected onGameDataParsed(data:FruitsParsedGameData):void {
        this._reelsEnteringBonus = data.reelsEnteringBonus;
        this._bonusOverlayPositions = data.bonusOverlayPositionsAfter;
        if(data.isBonusTriggeredThisSpin || data.isStickyRespinTriggeredThisSpin)
            this._currentBonusPaytable = data.bonusPayTableAfterSpin;
        else
            this._currentBonusPaytable = data.bonusPayTableBeforeSpin;
        this._nextBonusIndex = data.collectedScatterAfter;
        this._currentBonusIndex = data.collectedScatterBefore;
        FruitsGameModuleConfig.bonusOverlayView.setIndicatorInitVals(this._currentBonusPaytable, this._nextBonusIndex - 3);
        this._isRestoreState = false;

        EventHandler.dispatchEvent(new GameEvent(FruitsReelPartAnimator.REPLACE_X, false));

        if(this._bonusOverlayPositions && data!.mode === FruitsGameMode.BONUS_GAME)
            this.updateScatters();

    }

    private onInitDataParsed(data:FruitsParsedInitData):void {
        this._initialBonusPositions = data.bonusOverlayPositionsBefore;
        this._isRestoreState = FruitsGameModuleConfig.bonusOverlayView.restored = data.isRestoreState;
        this._currentBonusIndex = data.collectedScattersBefore;
        this._currentBonusPaytable = data.currentBonusPaytable;
        this._nextBonusIndex = data.collectedScattersAfter;
        FruitsGameModuleConfig.bonusOverlayView.setIndicatorInitVals(this._currentBonusPaytable, this._nextBonusIndex - 3);

        this._bonusOverlayPositions = data.bonusOverlayPositionsBefore;
        /*if(this._bonusOverlayPositions && data!.mode === FruitsGameMode.BONUS_GAME)
            this.updateScatters();*/

        if(data!.nextMode === FruitsGameMode.BONUS_GAME && this._isRestoreState && data!.mode === FruitsGameMode.STICKY_RESPIN) {
            //this.restoreReelsetToBeforeLastBonusSpin();
            //this.updateScatters();
        }
        EventHandler.dispatchEvent(new GameEvent(FruitsReelPartAnimator.REPLACE_X, false));
    }

    private onChangeMode(nextMode:FruitsGameMode):void {
        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add(() => {
            if(nextMode === FruitsGameMode.BONUS_GAME) {
                if(this._isRestoreState) {
                    /**Restore state*/
                    FruitsGameModuleConfig.bonusOverlayView.restoreBonus(this._initialBonusPositions, this._currentBonusIndex - 3, this._currentBonusPaytable);
                    EventHandler.dispatchEvent(new GameEvent(FruitsReelController.UPDATE_SCATTER_LEVEL, FruitsHelper.determineScatterLevel(this._currentBonusIndex - 2)));
                }
            }

            if(nextMode === FruitsGameMode.NORMAL) {
                this.restoreReelsetToBeforeBonus();
            }
        });

        timeline.play();
    }

    private restoreReelsetToBeforeBonus():void {
        let rInd:number = 0;
        let sInd:number = 0;

        this._reelsEnteringBonus.forEach(
            (column, rInd) => {
                sInd = 0;
                column.forEach((symName) => {
                    if(rInd > 1 || (rInd < 2 && sInd > 0)) {
                        let ind:number = rInd < 2 ? rInd * 2 + sInd - 1 : 3 + (rInd - 2) * 3 + sInd + 1;
                        let sym:FruitsReelSymbol | null;

                        for(let i:number = 0; i < 4; i++) {
                            sym = <FruitsReelSymbol>Reels.allSymbols(ind)[i];
                            if(sym)
                                sym.replaceWith(i === 1 ? symName : FruitsHelper.randomizeSymbol(), rInd);
                        }
                    }
                    sInd++;
                });
            }
        );
        this._isRestoreState = false;
    }

    public updateScatterLevel(index:number):void {
        this._currentScatterLevel = index;
    }

    private restoreReelsetToBeforeLastBonusSpin():void {
        FruitsGameModuleConfig.bonusOverlayView.resetScatterOverlay();
        this.updateScatters();
    }

    public startBonusRound(scatterPositions:boolean[], scatterCount:number):void {
        /**To update the nextSymbol to be created*/
        EventHandler.dispatchEvent(new GameEvent(FruitsReelController.UPDATE_SCATTER_LEVEL, FruitsHelper.determineScatterLevel(scatterCount - 2)));
        this.updateScatterLevel(FruitsHelper.determineScatterLevel(scatterCount - 2));
        FruitsGameModuleConfig.bonusOverlayView.setIndicator(this._currentBonusPaytable, scatterCount - 3);
        FruitsGameModuleConfig.bonusOverlayView.initScatters(scatterPositions);
        FruitsGameModuleConfig.bonusOverlayView.updateScatterColor(3, scatterCount);
        this.updateScatters();
    }

    private updateMultiplier(scatterCount:number):void {
        for(let i:number = 3; i < scatterCount; i++) {
            FruitsGameModuleConfig.bonusOverlayView.updateMultiplier(undefined, true);
        }
    }

    public updateScatters():void {
        let rInd:number = 0;
        let sInd:number = 0;
        this._bonusOverlayPositions.forEach(
            (column) => {
                sInd = 0;
                column.forEach((isScatter) => {
                    let ind:number = rInd * 3 + sInd;
                    for(let i:number = 0; i < 3; i++) {
                        let sym:FruitsReelSymbol | null = <FruitsReelSymbol>Reels.allSymbols(ind)[i];
                        if(sym) {
                            if(isScatter) {
                                switch(this._currentScatterLevel) {
                                    case 1:
                                        sym.replaceWith(("S"), rInd);
                                        break;
                                    case 2:
                                        sym.replaceWith(("S_B"), rInd);
                                        break;
                                    case 3:
                                        sym.replaceWith(("S_C"), rInd);
                                        break;
                                    case 4:
                                        sym.replaceWith(("S_D"), rInd);
                                        break;
                                    default:
                                        break;
                                }
                            }

                            else {
                                sym.replaceWith(("X"), rInd);
                            }
                        }
                    }
                    sInd++;
                });
                rInd++;
            }
        )
    }
}